export const PROMPT_LANGUAGES = [
    { code: 'EN', name: 'English' },
    { code: 'KO', name: 'Korean' },
    { code: 'ZH', name: 'Chinese' },
    { code: 'JA', name: 'Japanese' },
    { code: 'ES', name: 'Spanish' },
    { code: 'RU', name: 'Russian' },
    { code: 'FR', name: 'French' },
    { code: 'PT', name: 'Portuguese' },
    { code: 'DE', name: 'German' },
    { code: 'IT', name: 'Italian' },
    { code: 'NL', name: 'Dutch' },
    { code: 'ID', name: 'Indonesian' },
    { code: 'TL', name: 'Filipino' },
    { code: 'VI', name: 'Vietnamese' },
];
